import styled from 'styled-components';
import StreakCircleComponent from '../StreakCircle';
import { Typ32, Typ30 } from 'dc/Typ';
import Button from 'dc/Button';

export const Wrapper = styled(Button)`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 16px;
  cursor: pointer;
`;

export const StreakCircle = styled(StreakCircleComponent)`
  flex-shrink: 0;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px;
  width: 100%;
  text-align: initial;
`;

export const Title = styled(Typ32)`
  margin-bottom: 8px;
`;

export const Text = styled(Typ30)`
  opacity: 70%;
`;
